import React, { useState,useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import useLoadingState from '../../../Utils/Hooks/useLodingState';
import useOverlayState from '../../../Utils/Hooks/useOverlayState';
import { useAuth } from '../../../Store/AuthContext';
import { SideDrawer } from '../../atoms/Drawer/SideDrawer';
import { useForm } from 'react-hook-form';

import { NoRecordsFound } from '../../atoms/NoRecordsFound/NoRecordsFound';
import { Autocomplete, Stack } from '@mui/material';
import { TextInput } from '../../atoms/Input/TextInput';
import { addSpecialty,updateSpecialty } from '../../../Api/Specialty/Specialty.api';
import TextField from "@mui/material/TextField";
import { FormItemsWrap } from '../../molecules/Wrap/Wrap';
import Button from '@mui/material/Button';
import { LoadingButtonType } from '../../atoms/LoadingButton/LoadingButton';
import { Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { schema } from './shema';
import Label from '../../atoms/Input/Label';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import { ErrorSharp } from '@mui/icons-material';
import { SubHeader2 } from '../../atoms/Typography/SubHeader/SubHeader';
import { ReactComponent as Info } from "../../../Assets/Images/Info2.svg";

export const AddSpecialty = ({
  close,
  closeMain,
  data,
  OpenDrawer,
  loadSpecialties,
  mode,
  refetch,
 openParentOverlay}) => {

  const { state } = useAuth();
  const { t } =  useTranslation();
  const { LoadingState, startLoading, stopLoading } = useLoadingState();
  const { closeOverlay, OverlayState, openOverlay } = useOverlayState();


  const [doctorMasterData, setDoctorMasterData] = React.useState({
    selectedSpeciality: null,
  });


  const [isError, setIsError] = useState(false)


  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);

  // Set up react-hook-form with only the needed fields
  const {
    control,
    setValue,
    watch,
    setError,
    reset,
    handleSubmit,
    getValues,
    formState: { isDirty }
  } = useForm({
    defaultValues: {
      description: "",
      createdBy: "",  
       createdDate: "", 
    },
    mode: "onChange",
    resolver: yupResolver(schema(t)),
    criteriaMode: "all",
    reValidateMode: "onChange",
  });

const langCode = state?.lang?.code?.toUpperCase();



const createSpecialtyHandler = async (values) => {
    startLoading({ btnName: "create" });
    setIsError(false);
    const payload = {
      description: values.description, 
      language: langCode,

    };
    try{

  const response = await addSpecialty({
        specialty:payload
      });
      if (response.type === 0) {
        reset(); 
        openOverlay({
          OverlayName: "create-success", 
          mode: "success",             
          messages: {                  
            title: t('glossary:add-specialty'), 
            description: t("Specialty added successfully.", { ns: "glossary" })
          }
        });
      }
        else if (response.type === 2) { 
        console.log("Server validation error:", response.message);
        let errorMessage = t("An error occurred. Please try again.", { ns: "validation" }); 

        if (response.message === "speciality-exist") { 
          errorMessage = t("This specialty already exists. Please try again.", { ns: "validation" });
        } else if (response.message === "Admin creation failed") {
           errorMessage = t("Failed to create specialty admin.", { ns: "validation" }); 
        }
        setError("description", { message: errorMessage });
      }
        else { 
         console.log("Server error (non-type 0 or 2):", response);
         setError("description", {
             message: t("An unexpected server error occurred.", { ns: "validation" })
         });
      }
      }
      catch (error){
        console.error("Error creating doctor assistant:", error);
        setIsError(true);
      }
      finally{
        stopLoading();
    }
  }

 
  const updateSpecialtyHandler = async (values) => {
    startLoading({ btnName: "update" });
    setIsError(false);

    const payload = {
      specId: data.specId,            
      description: values.description,
      language: langCode,          
    };

    try {
      const response = await updateSpecialty({ specialty: payload });

      if (response.type === 0) {
  
          reset();
          close(); 
          openParentOverlay({ 
            OverlayName: "update-success",
            mode: "success",
            messages: {
              title: t('glossary:Edit Specialty'),
              description: t("Specialty successfully updated.")
            }
          });
      } else if (response.type === 2) { 
        console.log("Server validation error (update):", response.message);
        let errorMessage = t("An error occurred. Please try again.", { ns: "validation" });

      
        if (response.message === "speciality-exist") {
          errorMessage = t("Specialty already exists.", { ns: "validation" });
        }
    
        setError("description", { message: errorMessage });

      } else { 
        console.log("Server error (update, non-type 0 or 2):", response);
        setError("description", {
          message: t("An unexpected server error occurred.", { ns: "validation" })
        });
      }
    } catch (error) { 
      console.error("Error updating specialty:", error);
      setError("description", {
        message: t("An error occurred while contacting the server.", { ns: "validation" })
      });
      
    } finally {
      stopLoading();
    }
  };
  // Handler for cancel button click
 const handleCancelClick = () => {
  if (isDirty) {
    setShowCancelConfirmation(true); 
  } else {
    closeAndReset(); 
  }
};

  // Handler for confirming cancel action
  const handleConfirmCancel = () => {
    closeAndReset();
  };

  const closeAndReset = () => {
  setShowCancelConfirmation(false); 
  reset();
  close();
};

useEffect(() => {
  if (mode === "update" && data) {
    reset({
      description: data.description || "",
      createdBy: data.email || "",
      createdDate: data.createdOn
          ? new Date(data.createdOn).toLocaleDateString("en-GB", { timeZone: "Asia/Colombo" })
          : "",
    });
  }
}, [mode, data, reset]);



  return (
    <SideDrawer
     isLoading={LoadingState.visible}
      headingText={
        mode === "update"
          ? "Edit Specialty"
          : "New Specialty"
      }
      width={"690px"}
      openDrawer={OpenDrawer}
      close={handleCancelClick}
      anchorDrawer={"right"}
    >

    {isError && (
      <NoRecordsFound
        isError={isError}
        textPosition={"start"}
        padding={"8px"}
        textColor={"black"}
        label={"validation:server-error"}
      />
    )}

    <div style={{ paddingBottom: "20px",marginTop: "20px" }}>
      {OverlayState.OverlayName === "create-success" && (
                <ConfirmDialog
                  description={
                    mode === "update"
                      ? t("Specialty successfully updated.")
                      : t("Specialty successfully added.", { ns: "glossary" })
                  }
                  open={OverlayState.visible}
                  close={() => closeOverlay()}
                  onOkClick={() => {
                    reset();
                    loadSpecialties();
                    close();
                    closeOverlay();
                  }}
                />
      )}

      {/* Cancel Confirmation Dialog */}
      {showCancelConfirmation && (
        <ConfirmDialog
          title={"Cancel"}
          description={"Are you sure you want to proceed?"}
          open={showCancelConfirmation}
          close={() => setShowCancelConfirmation(false)}
          onNoClick={() => setShowCancelConfirmation(false)}
          onOkTitle={"Yes"}
          onNoTitle={"No"}
          onOkClick={handleConfirmCancel}
        />
      )}

      <form
        onSubmit={handleSubmit(async (formData) => {
            if (mode === "update") {
              await updateSpecialtyHandler(formData);
            } else {
              await  createSpecialtyHandler(formData);
            }
          })}
      >
        <Stack rowGap={"10px"} width={"640px"}>

          <TextInput
            required={true}
            name={"description"}
            control={control}
            label={"Specialty"}
          />
          {
            mode!== "update" && <SubHeader2
                icon={<Info role="img" type="img" aria-label="Info Icon" />}
                text="Allows letters, numbers, and special characters"
                /> 
          }

           { mode=== "update" &&      
          <TextInput
            required={false}
            name={"createdDate"}
            control={control}
            label={"Created date"}
            disabled
          /> }

          { mode=== "update" &&      
          <TextInput
            required={false}
            name={"createdBy"}
            control={control}
            label={"Created by"}
            disabled
          /> }

           <FormItemsWrap
              direction={"row"}
              justifyContent={"flex-end"}
              gap={"16px"}
            >
              <Button variant="whiteSquare" onClick={handleCancelClick}>
                {"Cancel"}
              </Button>
              <LoadingButtonType
                variant="primaryBlue"
                type="submit"
                loading={LoadingState.visible}
              >
                {mode === "update"
                  ? "Save"
                  : "Create Specialty"}
              </LoadingButtonType>
            </FormItemsWrap>

           
        </Stack>
      </form>
    </div>

    </SideDrawer>
  )
}